const initialState = {
  place_id: "",
  address: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SET_PLACE_DATA":
      return { ...state, ...action.payload };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/reducer/place.reducer.js